import styled from 'styled-components';

export const OuterSection = styled.section`
  width: 100%;
  padding: 20px 15px 30px 15px;
  @media (min-width: 360px) {
    padding: 20px 20px 30px 20px;
  }
  @media (min-width: 992px) {
    padding: 20px 0px 30px 0px;
  }
`;

export const InnerSection = styled.div`
  width: var(--layoutWidth);
  max-width: var(--layoutMaxWidth);
  margin: 0px auto;
  text-align: center;
`;

export const Title = styled.h2`
  display: inline-block;
  padding-bottom: 35px;
  color: var(--inputTxtColor);
  font-weight: 600 !important;
  line-height: 2.2rem;
  max-width: 340px;
  @media (min-width: 576px) {
    max-width: 370px;
  }
  @media (min-width: 768px) {
    max-width: 400px;
  }
  @media (min-width: 992px) {
    max-width: 430px;
  }
  @media (min-width: 1200px) {
    max-width: 460px;
  }
  @media (min-width: 1400px) {
    max-width: 490px;
  }
  @media (min-width: 2000px) {
    max-width: 520px;
  }
`;

export const TitleSpecialText = styled.span`
  display: inline-block;
  font-family: var(--headingFont);
  font-weight: 600 !important;
  color: ${({ variant }) =>
    variant === 'regionals'
      ? 'var(--regionalsDark)'
      : variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'var(--brandColor)'};
`;

export const TabsContainer = styled.div`
  width: 100%;
  margin: 0px auto;
`;

export const InterviewLabel = styled.label`
  display: inline-block;
  width: calc(100% / 3);
  padding: 8px 0px;
  font-size: 14px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: background-color 0.2s;
  cursor: pointer;
  :hover {
    background-color: ${({ variant }) =>
      variant === 'regionals' ? '#f8f0ff' : variant === 'partner-plus' ? '#e1ffe8' : variant === 'code-juniors' ? '#fff6f3' : 'var(--siteBorderColor)'};
  }
  @media (min-width: 768px) {
    font-size: 15px;
  }
  @media (min-width: 992px) {
    font-size: 16px;
  }
`;

export const ToggleTrack = styled.div`
  width: 100%;
  height: 6px;
  margin: 0px auto;
  position: relative;
  background-color: ${({ variant }) => (variant === 'regionals' || variant === 'partner-plus' || variant === 'code-juniors' ? 'var(--greyShadowColor)' : '#d9e4ff')};
  border-radius: 20px;
  overflow: hidden;
`;

export const ToggleThumb = styled.div`
  height: 100%;
  width: calc(100% / 3);
  border-radius: 20px;
  position: absolute;
  left: 0px;
  transition: transform 0.3s ease-out;
  transform: ${(props) => (props.activeTab === 'hint' ? 'translateX(100%)' : props.activeTab === 'solution' ? 'translateX(200%)' : 'translateX(0%)')};
  background: ${({ variant }) =>
    variant === 'regionals'
      ? 'var(--regionalsDark)'
      : variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'linear-gradient(90deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor))'};
`;

export const ContentContainer = styled.div`
  width: 100%;
  margin: 0px auto;
  padding-top: 40px;
  padding-bottom: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media (min-width: 992px) {
    text-align: left;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const ContentTextContainer = styled.div`
  width: 100%;
  padding-bottom: 25px;
  @media (min-width: 992px) {
    width: 30%;
    max-width: 280px;
    padding-bottom: 0px;
    padding-right: 30px;
  }
  @media (min-width: 1400px) {
    max-width: 300px;
  }
  @media (min-width: 2000px) {
    max-width: 320px;
  }
`;

export const ContentSpecialText = styled.h2`
  padding-bottom: 20px;
  font-weight: 600 !important;
  display: inline-block;
  color: ${({ variant }) =>
    variant === 'regionals' ? 'var(--regionalsDark)' : variant === 'partner-plus' ? 'var(--partnerPlusColor)' : variant === 'code-juniors' ? 'var(--codeJuniorsColor)' : ''};
  background: ${({ variant }) =>
    variant === 'regionals' || variant === 'partner-plus' || variant === 'code-juniors'
      ? ''
      : 'linear-gradient(90deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor))'};
  background-clip: ${({ variant }) => (variant === 'regionals' || variant === 'partner-plus' || variant === 'code-juniors' ? '' : 'text')};
  -webkit-text-fill-color: ${({ variant }) => (variant === 'regionals' || variant === 'partner-plus' || variant === 'code-juniors' ? '' : 'transparent')};
`;

export const ContentParaText = styled.p`
  font-size: 14px;
  color: var(--darkGreyTxtColor);
  padding-bottom: 15px;
  @media (min-width: 768px) {
    font-size: 15px;
  }
  @media (min-width: 1200px) {
    font-size: 16px;
  }
`;

export const ContentSecondaryText = styled.p`
  font-size: 14px;
  color: var(--darkGreyTxtColor);
  @media (min-width: 768px) {
    font-size: 15px;
  }
  @media (min-width: 1200px) {
    font-size: 16px;
  }
`;

export const ContentVideoContainer = styled.div`
  width: 100%;
  min-height: 160px;
  @media (min-width: 375px) {
    min-height: 200px;
  }
  @media (min-width: 481px) {
    min-height: 260px;
  }
  @media (min-width: 576px) {
    min-height: 310px;
  }
  @media (min-width: 768px) {
    min-height: 420px;
  }
  @media (min-width: 992px) {
    width: 70%;
    min-height: 360px;
  }
  @media (min-width: 1200px) {
    min-height: 380px;
  }
  @media (min-width: 1400px) {
    min-height: 440px;
  }
`;

export const ContentVideo = styled.object`
  width: 100%;
  border-radius: 15px;
  pointer-events: none;
  user-select: none;
`;
